/**
 * Present in the create-shipment design, hidden in the active UI.
 * Not wired to orders.
 */
function OrderSelectionField({ label }) {
  return (
    <div hidden>
      <label>
        {label}
        <select disabled aria-hidden="true" defaultValue="" />
      </label>
    </div>
  );
}

export default OrderSelectionField;
